
import Dashboard from "layouts/Dashboard.jsx";
import LoginPage from "views/Pages/LoginPage.jsx";
import Signup from "views/Pages/Signup.jsx";
import SignupProvider from "views/Pages/SignupProvider.jsx";
import RegisterPage from "views/Pages/RegisterPage.jsx";
import SignupEmployer from "views/Pages/SignupEmployer.jsx";
import ResetPassword from "views/Pages/ResetPassword.jsx";
import EnterNewPassword from "views/Pages/EnterNewPassword.jsx";
import Agreement from "views/Pages/SignupSteps/Agreement.jsx";
import Dentist from "views/Pages/SignupSteps/Dentist.jsx";
import Payment from "views/Pages/SignupSteps/Payment.jsx";
import Subscriptions from "views/Pages/Subscriptions.jsx";
import CreditCardProcessorSignupFinalize from "views/Pages/CreditCardProcessorSignupFinalize.jsx";

var indexRoutes = [];
if (sessionStorage.getItem('jwtToken') && sessionStorage.getItem('jwtToken') !== '') {
  if (sessionStorage.getItem('agreementAcknowledged') === 'false') {
    indexRoutes = [
      { path: "/", name: "Agreement", component: Agreement }
    ];
  } else if (sessionStorage.getItem('primaryDentist') === '') {
    indexRoutes = [
      { path: "/", name: "Dentist", component: Dentist }
    ];
  } else if (sessionStorage.getItem('planId') === '') {
    indexRoutes = [
      { path: "/", name: "Subscriptions", component: Subscriptions }
    ];
  } else if (sessionStorage.getItem('bankAccountSet') === 'false') {
    indexRoutes = [
      { path: "/", name: "Payment", component: Payment }
    ];
  } else {
    indexRoutes = [
      { path: "/enterNewPassword", name: "EnterNewPassword", component: EnterNewPassword },
      { path: "/creditCardProcessorSignupFinalize", name: "CreditCardProcessorSignupFinalize", component: CreditCardProcessorSignupFinalize },
      { path: "/", name: "Home", component: Dashboard },
    ];
  }
} else {
  indexRoutes = [
    { path: "/signup", name: "Signup", component: Signup },
    { path: "/signupProvider", name: "SignupProvider", component: SignupProvider },
    { path: "/signupEmployer", name: "SignupEmployer", component: SignupEmployer },
    { path: "/resetPassword", name: "ResetPassword", component: ResetPassword },
    { path: "/agreement", name: "Agreement", component: Agreement },
    { path: "/register", name: "RegisterPage", component: RegisterPage },
    { path: "/", name: "Login", component: LoginPage }
  ];
}

export default indexRoutes;